import React from 'react';

interface StepProps {
  recordId: string; // The record ID passed to the component
  handleClose: () => void; // Function to close the popup
  onUpdate: () => void; // Function to refresh the data after update
}

const BidAutomationLogPopup: React.FC<StepProps> = ({
  recordId,
  handleClose,
  onUpdate,
}) => {
  return (
    <div className="popup-container" style={{ padding: '20px', fontFamily: 'Arial, sans-serif', fontSize: '14px' }}>
      <div className="popup-header" style={{ marginBottom: '20px' }}>
        <h4 style={{ fontSize: '16px', margin: '0 0 10px 0' }}>Campaign: Bid Automation</h4>
      </div>
      <div className="popup-content" style={{ boxShadow: '0px 4px 6px rgba(0, 0, 0, 0.1)',height:'500px', border: '1px solid #ddd', padding: '20px' }}>
        <h5 style={{ fontSize: '14px', margin: '0 0 10px 0' }}>Bid Automation:</h5>
        <p style={{ fontSize: '12px', color: '#666', margin: '0' }}>Bid Automation is not enabled</p>
      </div>
      
    </div>
  );
};

export default BidAutomationLogPopup;
